import { makeVar } from '@apollo/client'

export interface ShowHideWorkspaceToggles {
    isTrackChangeToggleOn: boolean
}

const showHideTogglesInitial = {
    isTrackChangeToggleOn: true,
}

export const showHideToggles = makeVar<ShowHideWorkspaceToggles>({
    ...showHideTogglesInitial,
})

export const setIsTrackChangesToggleOn = (value: boolean) => {
    showHideToggles({ isTrackChangeToggleOn: value })
}
